import { z } from "zod";

const agendaColumnZodEnum = z.enum([
    "upcoming",
    "active", // incheckade och andra pågående
    "unhandled", // ej hanterade (visas om "idag"). T.ex. ej incheckade ordrar från tidigare.
    "fulfilled", // utcheckade och andra som är klara
]);
type AgendaColumnType = z.infer<typeof agendaColumnZodEnum>;

export { agendaColumnZodEnum };
export type { AgendaColumnType };
